var map = {
	"./1 - Kodiak Cathedral.jpeg": "./src/data/images/summer-session/1 - Kodiak Cathedral.jpeg",
	"./2- Metropolitan Tikhon 2021.jpeg": "./src/data/images/summer-session/2- Metropolitan Tikhon 2021.jpeg",
	"./3 - Boat ride from Kodiak to Spruce.jpeg": "./src/data/images/summer-session/3 - Boat ride from Kodiak to Spruce.jpeg",
	"./4 - Beach on Spruce Island.jpeg": "./src/data/images/summer-session/4 - Beach on Spruce Island.jpeg",
	"./5 - Chapel on Spruce Island.jpeg": "./src/data/images/summer-session/5 - Chapel on Spruce Island.jpeg",
	"./6 - Icon along the Path.jpeg": "./src/data/images/summer-session/6 - Icon along the Path.jpeg",
	"./ERI_Brochure_1.jpg": "./src/data/images/summer-session/ERI_Brochure_1.jpg",
	"./ERI_Brochure_2.jpg": "./src/data/images/summer-session/ERI_Brochure_2.jpg",
	"./ERI_Schedule.png": "./src/data/images/summer-session/ERI_Schedule.png",
	"./carrie-modal.jpg": "./src/data/images/summer-session/carrie-modal.jpg",
	"./church_aerial.jpeg": "./src/data/images/summer-session/church_aerial.jpeg",
	"./denysenko.jpg": "./src/data/images/summer-session/denysenko.jpg",
	"./drnassif.jpeg": "./src/data/images/summer-session/drnassif.jpeg",
	"./drregula.jpeg": "./src/data/images/summer-session/drregula.jpeg",
	"./dunaways.jpeg": "./src/data/images/summer-session/dunaways.jpeg",
	"./frberger.jpeg": "./src/data/images/summer-session/frberger.jpeg",
	"./frm.jpg": "./src/data/images/summer-session/frm.jpg",
	"./frmd.jpg": "./src/data/images/summer-session/frmd.jpg",
	"./frmo-modal.jpg": "./src/data/images/summer-session/frmo-modal.jpg",
	"./gayle-modal.jpg": "./src/data/images/summer-session/gayle-modal.jpg",
	"./hp.jpeg": "./src/data/images/summer-session/hp.jpeg",
	"./jillions.png": "./src/data/images/summer-session/jillions.png",
	"./kolosova.jpg": "./src/data/images/summer-session/kolosova.jpg",
	"./ladouceur.jpg": "./src/data/images/summer-session/ladouceur.jpg",
	"./mamalakis.jpeg": "./src/data/images/summer-session/mamalakis.jpeg",
	"./paul-modal.jpg": "./src/data/images/summer-session/paul-modal.jpg",
	"./pilgrimage.jpg": "./src/data/images/summer-session/pilgrimage.jpg",
	"./podcasts.jpg": "./src/data/images/summer-session/podcasts.jpg",
	"./roccas.jpeg": "./src/data/images/summer-session/roccas.jpeg",
	"./sidebar.jpg": "./src/data/images/summer-session/sidebar.jpg",
	"./soda_lake.jpg": "./src/data/images/summer-session/soda_lake.jpg",
	"./speakers.jpg": "./src/data/images/summer-session/speakers.jpg",
	"./telly.jpg": "./src/data/images/summer-session/telly.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/data/images/summer-session sync \\.(png|jpe?g|svg)$";